<app-navbar title="Terminy"></app-navbar>
<div class="row filters-row m-2">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button class="me-4" mat-raised-button color="primary" (click)="filtersOpen()">
			<i class="fas fa-filter"></i>
		</button>
	</div>
</div>
<app-terms-filters
	userFilters="terms"
	[yesno]="parameters.yesno"
	[products]="parameters.products"
	[groupOffers]="parameters.groupOffers"
	[locations]="parameters.locations"
	(selected)="filtersSelected($event)"
	[forceFilters]="{ limit: 9999 }"
></app-terms-filters>

<ng-container *ngIf="showTable">
	<mat-table
		[dataSource]="matData"
		matSort
		matSortActive="id"
		matSortDirection="asc"
		grouping="false"
		cdkDropList
		cdkDropListDisabled="true"
	>
		<ng-container matColumnDef="checkbox">
			<mat-header-cell *matHeaderCellDef>
				<mat-checkbox color="primary" (change)="selectAll($event)"></mat-checkbox>
			</mat-header-cell>
			<mat-cell *matCellDef="let element; let i = index"
				><mat-checkbox
					color="primary"
					[(ngModel)]="element.checked"
					(click)="checkMultipleSelection($event, i)"
				></mat-checkbox
			></mat-cell>
		</ng-container>

		<ng-container matColumnDef="id">
			<mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.id }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="product">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Produkt </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				{{ element.product.name }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="locations">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Lokalizacje </mat-header-cell>
			<mat-cell *matCellDef="let element" class="displayMaxTwoResults mat-cell-big"
				><div class="d-grid me-2">
					<span class="mt-1" *ngFor="let funct of element.locations.slice(0, 2)">{{ funct }}</span>
				</div>

				<button
					mat-mini-fab
					color="primary"
					class="my-1 disabled"
					*ngIf="element.locations.length > 2"
					matTooltip="{{ element.locations.slice(2) }}"
				>
					+ {{ element.locations.length - 2 }}
				</button>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="nightsNumber">
			<mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="qwe"> Noclegi </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ getNightsNumber(element.dateRange.upper, element.dateRange.lower) }}
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="dateRangeLower">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Od </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<ng-container *ngIf="element.dateRange.lower">
					{{ element.dateRange.lower }}
				</ng-container>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="dateRangeUpper">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Do </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				<ng-container *ngIf="element.dateRange.upper">
					{{ element.dateRange.upper }}
				</ng-container>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="transportKind">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Transport </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				@if (element.transportKind) {
					<ng-container>
						@if (element.transportKind === 'C') {
							<i class="fas fa-bus d-flex align-items-center"></i>
						}
						@if (element.transportKind === 'F') {
							<i class="fas fa-plane d-flex align-items-center"></i>
						}
					</ng-container>
				}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="stopSale">
			<mat-header-cell
				*matHeaderCellDef
				mat-sort-header
				matTooltip="Zamykanie sprzedaży niezależnie od kanału (Sprzedaż, WWW, MerlinX)"
			>
				StopSALE
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2 reversed"
					[(ngModel)]="element.stopSale"
					[disabled]="element.archived"
					(change)="sendData([element])"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="www">
			<mat-header-cell
				*matHeaderCellDef
				mat-sort-header
				matTooltip="Blokada sprzedaży dla klientów na stronie internetowej"
			>
				WWW
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2"
					[(ngModel)]="element.www"
					[disabled]="element.archived || element.stopSale"
					(change)="sendData([element])"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>

		<ng-container matColumnDef="merlinx">
			<mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Blokada sprzedaży w MerlinX">
				MerlinX
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2"
					[(ngModel)]="element.merlinx"
					[disabled]="element.archived || element.stopSale"
					(change)="sendData([element])"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="promotion">
			<mat-header-cell
				*matHeaderCellDef
				mat-sort-header
				matTooltip="Określa, czy w tym terminie można zastosować jakąkolwiek promocję"
			>
				Promocja
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2"
					[(ngModel)]="element.promotion"
					[disabled]="element.archived || element.stopSale"
					(change)="sendData([element])"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="archived">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Archiwum </mat-header-cell>
			<mat-cell *matCellDef="let element">
				<mat-slide-toggle
					class="ms-2"
					[(ngModel)]="element.archived"
					(click)="askQuestionArchive($event, element)"
				>
				</mat-slide-toggle>
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="status">
			<mat-header-cell *matHeaderCellDef mat-sort-header> Status </mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.status }}
			</mat-cell>
		</ng-container>
		<ng-container matColumnDef="offerName">
			<mat-header-cell *matHeaderCellDef mat-sort-header class="mat-cell-big"> Nazwa oferty </mat-header-cell>
			<mat-cell *matCellDef="let element" class="mat-cell-big">
				{{ element.offerName }}
			</mat-cell>
		</ng-container>
		<!-- <ng-container matColumnDef="termPrice">
			<mat-header-cell *matHeaderCellDef mat-sort-header>
				Cena
			</mat-header-cell>
			<mat-cell *matCellDef="let element">
				{{ element.termPrice === null ? "brak" : element.termPrice }}
			</mat-cell>
		</ng-container> -->

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>

	<div class="footer">
		<mat-paginator
			[pageSizeOptions]="[10, 20, 50]"
			[pageSize]="50"
			showFirstLastButtons
			aria-label="Select page of periodic elements"
		>
		</mat-paginator>
		<ng-select id="products" name="products" placeholder="Wybierz kolumne" [(ngModel)]="action.type">
			<ng-option *ngFor="let item of parameters.massAction" [value]="item.value">{{ item.name }}</ng-option>
		</ng-select>
		<ng-select id="products" class="ms-4" name="products" placeholder="Wybierz opcje" [(ngModel)]="action.value">
			<ng-option *ngFor="let item of parameters.yesno" [value]="item.value">{{ item.name }}</ng-option>
		</ng-select>
		<button class="mx-4 my-auto" mat-raised-button color="primary" (click)="massAction()">
			<i class="fa-regular fa-pen-to-square"></i>
			Ustaw zaznaczonym
		</button>
	</div>
</ng-container>
<ng-container *ngIf="!showTable">
	<div class="h-100 d-flex flex-column">
		<div class="no-results-container d-flex flex-column">
			<i class="fa-solid fa-face-sad-tear fa-6x"></i>
			<p class="mt-5">Nie znaleziono żadnych terminów</p>
			<p>Wyczyść filtry lub wygeneruj terminy w zakładce "Grupy ofert"</p>
		</div>
	</div>
</ng-container>
